<div class="mb-16 flex flex-col">
  <div class="mx-auto mb-6 mt-10 flex w-[90%] items-center justify-between">
    <h1 class="text-3xl">Gastos</h1>
    <div class="flex gap-4">
      <button
        (click)="createGasto()"
        class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
      >
        <mat-icon aria-hidden="false" aria-label="icono añadir gasto" fontIcon="add" />
        Nuevo Gasto
      </button>
      <button
        (click)="goToGastosNoProcesables()"
        class="btn flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-blue bg-blue px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
      >
        <mat-icon aria-hidden="false" aria-label="icono añadir gasto" fontIcon="bug_report" />
        Gastos No Procesables
      </button>
    </div>
  </div>
  <ag-grid-angular
    style="min-width: 90%; height: 75vh"
    class="ag-theme-quartz mx-auto"
    [rowData]="gastos"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    (rowDoubleClicked)="onRowDoubleClicked($event)"
  />
</div>
